import { query } from "@solidjs/router";

import {
	getByPKQueryServer,
	getByRowTypeServer,
	getByUserQueryServer,
	getProfileQueryServer,
	getProjectCertificatesServer,
	getUserCertificatesServer,
	getCognitoProfile,
	getUserSubscriptionsServer,
} from "~/_server/dynamoQueries";

export const getUserInfoQuery = query(getCognitoProfile, "userInfo");

export const getUserCertificates = query(
	getUserCertificatesServer,
	"getUserCertificates",
);

export const getUserSubscriptions = query(
	getUserSubscriptionsServer,
	"getUserSubscriptions",
);

export const getProjectCertificates = query(
	getProjectCertificatesServer,
	"getProjectCertificates",
);

export const getByUserQuery = query(getByUserQueryServer, "getByUser");

export const getByRowType = query(getByRowTypeServer, "getByRowType");

export const getProfileQuery = query(getProfileQueryServer, "profileInfo");

export const getByPKQuery = query(getByPKQueryServer, "queryByPK");
